import { BANNER_HEIGHT } from '@modules/infoBanner/constants';
import { useIsInfoBannerVisible } from '@modules/infoBanner/hooks';
import { ChevronRightRounded } from '@mui/icons-material';
import { alpha, Box } from '@mui/material';
import { WisdomChatListDrawerToggleButton } from '../WisdomChatListDrawerToggleButton';

interface WisdomChatListDrawerIndicatorProps {
  toggleSidebar: () => void;
}

export const WisdomChatListDrawerIndicator = ({
  toggleSidebar,
}: WisdomChatListDrawerIndicatorProps) => {
  const isInfoBannerVisible = useIsInfoBannerVisible();

  return (
    <Box
      sx={{
        position: 'relative',
        height: isInfoBannerVisible
          ? `calc(100vh - ${BANNER_HEIGHT}px)`
          : '100vh',
        borderRight: (theme) =>
          `1px solid ${alpha(theme.palette.divider, 0.12)}`,
        background: (theme) => theme.palette.misc?.drawer.background,
        width: 12,
        ml: '1px',
        cursor: 'pointer',
        zIndex: (theme) => theme.zIndex.drawer - 1,
      }}
      onClick={toggleSidebar}
    >
      <Box
        position="absolute"
        sx={{ top: '50%', left: '4px', transform: 'translateY(-50%)' }}
      >
        <WisdomChatListDrawerToggleButton
          icon={
            <ChevronRightRounded
              sx={{ color: (theme) => theme.palette.primary.contrastText }}
            />
          }
        />
      </Box>
    </Box>
  );
};
